/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InvitationStatus = 'Created' | 'Sent' | 'Used' | 'Expired' | 'Cancelled' | 'Error';

export const InvitationStatus = {
    Created: 'Created' as InvitationStatus,
    Sent: 'Sent' as InvitationStatus,
    Used: 'Used' as InvitationStatus,
    Expired: 'Expired' as InvitationStatus,
    Cancelled: 'Cancelled' as InvitationStatus,
    Error: 'Error' as InvitationStatus
};

